import React from "react";

const EventView = ({ currentRecord }) => {
  const isImageFile = (filename) => {
    const imageExtensions = [".jpg", ".jpeg", ".png", ".gif", ".bmp", ".webp"];
    return imageExtensions.some((ext) => filename?.toLowerCase().endsWith(ext));
  };

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    return `${month}-${day}-${year} ${hours}:${minutes}`;
  };

  return (
    <div className="w-full overflow-y-auto bg-white rounded-lg shadow-sm">
      <div className="flex flex-col p-6">
        {/* Header Section */}
        <div className="mb-6">
          <h1 className="mb-2 text-2xl font-bold text-gray-900">
            {currentRecord?.title}
          </h1>
          <p className="text-sm text-gray-500">
            Created on {formatDate(currentRecord?.createdAt)}
          </p>
        </div>

        {/* Media Section */}
        <div className="flex items-center justify-center w-full p-4 mb-6 rounded-lg bg-gray-50">
          {currentRecord?.image &&
            (isImageFile(currentRecord.image) ? (
              <img
                crossOrigin="anonymous"
                src={`${process.env.REACT_APP_REPORTS_DOWNLOAD_URL}uploads/news/${currentRecord?.image}`}
                alt={currentRecord?.title}
                className="h-auto max-w-full rounded-lg shadow-sm"
              />
            ) : (
              <div className="flex flex-col items-center gap-3">
                <svg
                  className="w-12 h-12 text-gray-400"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z"
                  />
                </svg>
                <a
                  href={`${process.env.REACT_APP_REPORTS_DOWNLOAD_URL}uploads/news/${currentRecord?.image}`}
                  download
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center px-4 py-2 text-sm font-medium text-white transition-colors duration-200 bg-blue-600 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                >
                  <svg
                    className="w-4 h-4 mr-2"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
                    />
                  </svg>
                  Download File
                </a>
              </div>
            ))}
        </div>

        {/* Content Section */}
        <div className="bg-white rounded-lg">
          <div className="prose max-w-none">
            <h2 className="mb-3 text-lg font-semibold text-gray-900">
              Description
            </h2>
            <div className="text-gray-700 whitespace-pre-wrap">
              {currentRecord?.description}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EventView;
